type ProcessDisplay = { label: string; appName: string | null };

// The backend gives us `process_name` (the OS executable) but no friendly name,
// so we map known executables to the canonical app names that AppIcon knows.
// Unknown executables fall back to the raw process name with no icon.
const EXE_TO_APP: Record<string, string> = {
	"OUTLOOK.EXE": "Microsoft Outlook",
	"WINWORD.EXE": "Microsoft Word",
	"EXCEL.EXE": "Microsoft Excel",
	"POWERPNT.EXE": "Microsoft Powerpoint",
	"ACROBAT.EXE": "Adobe Acrobat",
	"ACRORD32.EXE": "Adobe Acrobat",
	"TEAMS.EXE": "Microsoft Teams",
	"MS-TEAMS.EXE": "Microsoft Teams",
	"ZOOM.EXE": "Zoom",
};

export function getProcessDisplay(processName: string): ProcessDisplay {
	const appName = EXE_TO_APP[processName?.toUpperCase().trim()];
	return {
		label: appName ?? processName ?? "Unknown app",
		appName: appName ?? null,
	};
}
